import { nomeDaRodada } from './rodadas';

/**
 * Qual rodada está na tela. Em propostas, equalização e análise os números
 * mudam de uma rodada para outra — a escolhida precisa saltar aos olhos, e a
 * mais recente vem marcada.
 */
export default function SeletorDeRodada({
  rodadas,
  atual,
  aoEscolher,
}: {
  rodadas: { id: number; numero: number }[];
  atual: number | null;
  aoEscolher: (id: number) => void;
}) {
  const ultima = rodadas[rodadas.length - 1]?.id;

  return (
    <div className="flex flex-wrap items-center gap-sm">
      <span className="text-[11px] font-bold tracking-wide text-muted uppercase">Rodada</span>
      <div role="group" aria-label="Rodada de negociação" className="flex flex-wrap gap-xs">
        {rodadas.map((rodada) => {
          const escolhida = rodada.id === atual;

          return (
            <button
              key={rodada.id}
              type="button"
              onClick={() => aoEscolher(rodada.id)}
              aria-pressed={escolhida}
              className={[
                'inline-flex items-center gap-xs rounded-full border px-md py-xs text-[13px] font-bold whitespace-nowrap transition-colors',
                escolhida
                  ? 'border-accent bg-accent text-white shadow-sm'
                  : 'border-border bg-surface text-ink-soft hover:border-accent hover:text-ink',
              ].join(' ')}
            >
              {nomeDaRodada(rodada.numero)}
              {rodada.id === ultima && rodadas.length > 1 && (
                <span
                  className={`rounded-full px-[6px] text-[10px] uppercase ${escolhida ? 'bg-white/20 text-white' : 'bg-success/10 text-success'}`}
                >
                  atual
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
